import { Controller } from "@hotwired/stimulus"

// Toast notification controller for auto-dismissing flash messages
//
// Usage:
//   <div data-controller="toast" data-toast-duration-value="3000">
//     <div data-toast-target="item" class="toast-item">Message</div>
//   </div>
//
export default class extends Controller {
  static targets = ["item"]
  static values = {
    duration: { type: Number, default: 3000 }
  }

  itemTargetConnected(element) {
    // Add enter animation
    requestAnimationFrame(() => {
      element.classList.remove("translate-x-full", "opacity-0")
      element.classList.add("translate-x-0", "opacity-100")
    })

    // Auto dismiss after duration
    this.scheduleRemoval(element)
  }

  scheduleRemoval(element) {
    setTimeout(() => {
      this.dismiss(element)
    }, this.durationValue)
  }

  dismiss(element) {
    // Add exit animation
    element.classList.remove("translate-x-0", "opacity-100")
    element.classList.add("translate-x-full", "opacity-0")

    // Remove from DOM after animation
    setTimeout(() => {
      element.remove()
    }, 300)
  }

  // Manual dismiss via click
  close(event) {
    const item = event.target.closest("[data-toast-target='item']")
    if (item) {
      this.dismiss(item)
    }
  }
}
